
















  import Vue from 'vue'
  import { Component, Prop } from 'vue-property-decorator'
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  import { namespace } from 'vuex-class'
  import { AxiosError } from 'axios'
  const products = namespace('products')
  const stocks = namespace('stocks')

  @Component({
    components: {
      Swiper,
      SwiperSlide,
      OneCmsProductParser: () => import('~/components/organisms/grid/shared/OneCmsProductParser.vue'),
      OneCmsDynamicComponent: () => import('~/components/organisms/grid/shared/OneCmsDynamicComponent.vue'),
    },
  })
  export default class OneCmsProductsRotator extends Vue {
    name: string = 'OneCmsProductsRotator'

    @products.Action fetchProductsById: any
    @products.Action fetchPricesForProducts: any
    @products.Getter getProduct: any

    @stocks.Action fetchStocksForProductsAndWarehouses: any
    @stocks.Getter getWarehouses: any

    @Prop({
      required: true,
      type: Array,
    })
    readonly products!: Array<string>

    @Prop({
      required: true,
      type: String,
    })
    readonly html!: string

    @Prop({
      required: true,
      type: Number,
    })
    readonly slidesPerView!: number

    @Prop({
      required: true,
      type: Number,
    })
    readonly spaceBetween!: number

    @Prop({
      required: true,
      type: Boolean,
    })
    readonly navigation!: Boolean

    isLoading: boolean = true
    isIntersected: boolean = false
    intersectionObserver: IntersectionObserver | null = null

    get swiperOptions() {
      return {
        spaceBetween: 50,
        slidesPerView: 1,
        centeredSlides: true,
        breakpoints: {
          1450: {
            centeredSlides: false,
            slidesPerView: 6,
            spaceBetween: 80,
          },
          1024: {
            centeredSlides: false,
            slidesPerView: 4,
            spaceBetween: 20,
          },
          782: {
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: 50,
          },
          640: {
            centeredSlides: false,
            slidesPerView: 2,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      }
    }

    async created() {
      await this.fetchProductsById(this.products)
    }

    mounted() {
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(async (entry) => {
            if (entry.isIntersecting && !this.isIntersected) {
              this.isIntersected = true
              await this.fetchData()
              this.intersectionObserver?.unobserve(this.$el)
            }
          })
        },
        {
          rootMargin: '200px',
        },
      )
      this.intersectionObserver.observe(this.$el)
    }

    beforeDestroy() {
      this.intersectionObserver?.disconnect()
    }

    async fetchData() {
      if (this.$utils.hasPricesEnabled) {
        await this.fetchPricesForProducts(this.products).catch((e: AxiosError) => this.$logger.warn({ e }))
      }
      await this.fetchStocksForProductsAndWarehouses({
        skus: this.products,
        warehouses: this.getWarehouses,
      }).catch((e: AxiosError) => this.$logger.warn({ e }))
      this.isLoading = false
    }
  }
